export const stubResponse = [
    {
      id: "779e0e18-db16-46d5-a256-40bae6ae41f9",
      name: "Random1",
      email: "vasu@acciojob.com",
      role: "ADMIN",
      isEmailVerified: true,
      status: "Invited",
    },
    {
      id: "275105ed-f1ef-40e9-a1c4-cf6b524a6fc9",
      name: "Random2",
      email: "vasuhuria23@gmail.com",
      role: "VIEWER",
      isEmailVerified: true,
      status: "Invited",
    },
    {
      id: "779e0e18-db16-46d5-a256-40bae6ae41f8",
      name: "Vasu",
      email: "vasu@acciojob.com",
      role: "ADMIN",
      isEmailVerified: true,
      status: "Invited",
    },
    {
      id: "275105ed-f1ef-40e9-a1c4-cf6b524a6fc8",
      name: "Random 3S",
      email: "vasuhuria23@gmail.com",
      role: "VIEWER",
      isEmailVerified: true,
      status: "Invited",
    },
    {
      id: "f591a64c-cd0e-4949-9cd3-3ca7b745e7f9",
      name: "himadri",
      email: "sadaf@acciojob.com",
      role: "VIEWER",
      isEmailVerified: true,
      status: "Invited",
    },
    {
      id: "a37b9195-327c-46d7-85f0-ecb3b1f4ac38",
      name: "kumar",
      email: "ankush@acciojob.com",
      role: "ADMIN",
      isEmailVerified: true,
      status: "Invited",
    },
    {
      id: "779e0e18-db16-46d5-a256-40bae6ae41f7",
      name: "Vasu",
      email: "vasu@acciojob.com",
      role: "ADMIN",
      isEmailVerified: true,
      status: "Invited",
    },
    {
      id: "275105ed-f1ef-40e9-a1c4-cf6b524a6fc7",
      name: "vasu huria",
      email: "vasuhuria23@gmail.com",
      role: "VIEWER",
      isEmailVerified: true,
      status: "Invited",
    },
    {
      id: "f591a64c-cd0e-4949-9cd3-3ca7b745e7f5",
      name: "himadri",
      email: "sadaf@acciojob.com",
      role: "VIEWER",
      isEmailVerified: true,
      status: "Invited",
    },
    {
      id: "a37b9195-327c-46d7-85f0-ecb3b1f4ac32",
      name: "kumar",
      email: "ankush@acciojob.com",
      role: "ADMIN",
      isEmailVerified: true,
      status: "Invited",
    },
    {
      id: "f591a64c-cd0e-4949-9cd3-3ca7b745e7l9",
      name: "himadri",
      email: "sadaf@acciojob.com",
      role: "VIEWER",
      isEmailVerified: true,
      status: "Invited",
    },
    {
      id: "a37b9195-327c-46d7-85f0-ecb3b1f4ac28",
      name: "kumar",
      email: "ankush@acciojob.com",
      role: "ADMIN",
      isEmailVerified: true,
      status: "Invited",
    },
  ];